// extracted by mini-css-extract-plugin
export default {"items":"loc_ite_2w-WC"};